import { PushClient, AccountsPushClient, CommonPushClient } from './push-client'

/**
 * Generic Push Client instance
 */
export const Push = new PushClient()

/**
 * Accounts Push Client instance
 */
export const AccountsPush = new AccountsPushClient()

/**
 * Common Push Client instance
 */
export const CommonPush = new CommonPushClient()
